import React from 'react'
import styled from '@emotion/styled'

const Icon = styled.svg`
  .cls-1 {
    fill: #fff;
  }
`
export const TimelineIcon = () => {
  return (
    <Icon viewBox="0 0 50 55">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_13" data-name="Layer 13">
          <g>
            <g>
              <rect className="cls-1" y="4" width="2" height="27" />
              <rect className="cls-1" x="4" width="2" height="31" />
              <rect className="cls-1" x="8" y="6" width="2" height="25" />
              <rect className="cls-1" x="12" y="10" width="2" height="21" />
              <rect className="cls-1" x="16" y="14" width="2" height="17" />
              <rect
                className="cls-1"
                x="20"
                y="15.42"
                width="2"
                height="15.58"
              />
              <rect
                className="cls-1"
                x="24"
                y="16.83"
                width="2"
                height="14.17"
              />
              <rect
                className="cls-1"
                x="28"
                y="20.38"
                width="2"
                height="10.63"
              />
              <rect className="cls-1" x="32" y="22.5" width="2" height="8.5" />
              <rect
                className="cls-1"
                x="36"
                y="23.92"
                width="2"
                height="7.08"
              />
              <rect
                className="cls-1"
                x="40"
                y="24.63"
                width="2"
                height="6.38"
              />
              <rect className="cls-1" x="44" y="28" width="2" height="3" />
              <rect className="cls-1" x="48" y="30" width="2" height="1" />
            </g>
            <g>
              <rect className="cls-1" y="33" width="2" height="14" />
              <rect className="cls-1" x="4" y="33" width="2" height="17.71" />
              <rect className="cls-1" x="8" y="33" width="2" height="14.29" />
              <rect className="cls-1" x="12" y="33" width="2" height="12" />
              <rect className="cls-1" x="16" y="33" width="2" height="22" />
              <rect className="cls-1" x="20" y="33" width="2" height="17" />
              <rect className="cls-1" x="24" y="33" width="2" height="11" />
              <rect className="cls-1" x="28" y="33" width="2" height="12" />
              <rect className="cls-1" x="32" y="33" width="2" height="9" />
              <rect className="cls-1" x="36" y="33" width="2" height="7.08" />
              <rect className="cls-1" x="40" y="33" width="2" height="5" />
              <rect className="cls-1" x="44" y="33" width="2" height="3" />
              <rect className="cls-1" x="48" y="33" width="2" height="1" />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
